// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"64":"chunk-common","143":"app","736":"vendor"}[chunkId] || chunkId) + "." + {"64":"de92a646","143":"0aac5d64","494":"786c49c5","532":"25b4c6f9","736":"d7805bea","969":"e3f9583a"}[chunkId] + ".css";
};